import gql from 'graphql-tag';
export const GET_COLLECTION_ITEM_ORDER_DATA = gql`
    query GetCollectionWithCustomFields($id: ID!, $maxVariants: Int!) {
        collection(id: $id) {
            id
            name
            customFields {
                itemOrderData
            }
            productVariants(options: { take: $maxVariants }) {
                items {
                    id
                    name
                    sku
                    featuredAsset {
                        id
                        preview
                    }
                    product {
                        id
                        name
                        slug
                        featuredAsset {
                            id
                            preview
                        }
                    }
                }
            }
        }
    }
`;

export const PREVIEW_COLLECTION_ITEM_ORDER_DATA = gql`
    query PreviewCollectionItemOrderData($input: PreviewCollectionVariantsInput!, $maxVariants: Int!) {
        previewCollectionVariants(input: $input, options: { take: $maxVariants }) {
            items {
                id
                name
                sku
                featuredAsset {
                    id
                    preview
                }
                product {
                    id
                    name
                    slug
                    featuredAsset {
                        id
                        preview
                    }
                }
            }
        }
    }
`;

export const GET_PRODUCT_REVIEW = gql`
    query GetProductReview($productReviewId: ID!) {
        productReview(id: $productReviewId) {
            id
            summary
            body
            rating
            authorName
            state
            product {
                id
                name
                slug
            }
        }
    }
`;

export const GET_REVIEWS_FOR_PRODUCT = gql`
    query GetReviewForProduct($productId: ID!, $options: ProductReviewListOptions) {
        product(id: $productId) {
            id
            reviews(options: $options) {
                items {
                    id
                    summary
                    body
                    rating
                    authorName
                    state
                    featuredAsset {
                        id
                    }
                }
                totalItems
            }
        }
    }
`;

export const GET_PAGE = gql`
    query GetPage($id: ID!) {
        page(id: $id) {
            id
            name
            slug
        }
    }
`;
